import { FormattedMessage, FormattedNumber } from 'react-intl';
import type CurrencyCode from '@alltrails/core/types/CurrencyCode';
import Bell from '@alltrails/denali/icons/Bell';
import LockOpen from '@alltrails/denali/icons/LockOpen';
import Star from '@alltrails/denali/icons/Star';
import classNames from 'classnames';
import type PurchaseTier from '@alltrails/core/types/PurchaseTier';
import styles from './TrialReminder.module.scss';

type Props = {
  currencyCode: CurrencyCode;
  cost: number;
  tier: PurchaseTier;
  selected: boolean;
};

const TrialReminderRow = ({ icon, message, tier }: { icon: React.ReactNode; message: React.ReactNode; tier: PurchaseTier }) => {
  return (
    <div className={styles.trialReminderRow}>
      <span className={classNames(styles.trialReminderRowIcon, { [styles.plus]: tier === 'plus', [styles.peak]: tier === 'peak' })}>{icon}</span>
      <span>{message}</span>
    </div>
  );
};

// Designs: https://www.figma.com/design/PtYSSpohQ9rL7ZWCcdsYJK/2025-Upsell-System?node-id=14878-213417&t=QkyXqJzur1tWw9aA-4
const TrialReminder = ({ currencyCode, cost, tier, selected }: Props) => {
  const iconColor = tier === 'peak' ? '--color-text-peak' : '--color-text-plus';
  return (
    <div className={classNames(styles.trialReminderWrapper, { [styles.selected]: selected })}>
      <div className={styles.trialReminderContainer}>
        <TrialReminderRow
          icon={<LockOpen color={iconColor} size="xs" />}
          message={<FormattedMessage defaultMessage="<b>Today:</b> Start your free trial" values={{ b: chunks => <b>{chunks}</b> }} />}
          tier={tier}
        />
        <TrialReminderRow
          icon={<Bell color={iconColor} size="xs" />}
          message={<FormattedMessage defaultMessage="<b>Day 5:</b> Get a trial reminder" values={{ b: chunks => <b>{chunks}</b> }} />}
          tier={tier}
        />
        <TrialReminderRow
          icon={<Star color={iconColor} size="xs" />}
          message={
            <FormattedMessage
              defaultMessage="<b>Day 7:</b> You’ll be charged {annualCost}/year"
              values={{ b: chunks => <b>{chunks}</b>, annualCost: <FormattedNumber currency={currencyCode} style="currency" value={cost} /> }}
            />
          }
          tier={tier}
        />
      </div>
    </div>
  );
};

export default TrialReminder;
